import React, {useEffect, useState} from 'react'
import {Button, ParagraphText} from '@thryvlabs/maverick'
import {ADDONS_TYPES, BILLING_PREFERENCES} from '../../utils/constants'

const getProduct = (item, quantity, currency) => {
  const availablePlan = item['monthly']
  const productPayment = availablePlan[0]
  if (!productPayment) return

  const productPrice =
    productPayment.currencies.find(x => x.currency === currency)?.unitAmount ||
    0

  const price = Number(
    (quantity ? productPrice * quantity : productPrice).toFixed(2),
  )
  const product = {
    id: productPayment.id,
    product: item.name,
    type: ADDONS_TYPES['ADD_ON'],
    price: `$${price
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`,
    billingPreference: BILLING_PREFERENCES[0],
    planCode: availablePlan[0].code,
    disableApps: item.disableApps || [],
    quantity,
  }
  return product
}

export function SocialAdsV4({
  item,
  addProduct,
  removeProduct,
  updateProduct,
  listOfProducts,
  currentAddOns,
  currency,
  maxQuantity = 5,
  // Geo Add-On only (FULSAS-13425): Social Ads keeps the original
  // floor-at-1 behavior by leaving this at its default.
  lockOwnedQuantity = false,
}) {
  const itemCurrency = currency
  const code = item.monthly[0].code
  const defaultProduct = currentAddOns?.find(addOn => addOn.addOnCode === code)
  const inListProduct = listOfProducts?.find(
    product => product.planCode === code,
  )
  const [quantity, setQuantity] = useState(defaultProduct?.quantity || 0)
  const minQuantity = lockOwnedQuantity
    ? defaultProduct?.quantity || 0
    : defaultProduct
    ? 1
    : 0
  const socialAdsAddOn = item.monthly[0].currencies.find(({currency}) => {
    return currency === itemCurrency
  })
  const itemPrice = socialAdsAddOn?.unitAmount * quantity
  useEffect(() => {
    if (defaultProduct?.quantity) {
      addProduct([getProduct(item, defaultProduct.quantity, currency)])
    }
  }, [defaultProduct?.quantity, item])

  function handleAdd(newQuantity) {
    if (newQuantity > maxQuantity) return
    setQuantity(newQuantity)
    if (inListProduct) {
      updateProduct({
        ...getProduct(item, newQuantity, currency),
        quantity: newQuantity,
      })
    } else {
      addProduct([getProduct(item, newQuantity, currency)])
    }
  }

  function handleRemove(newQuantity) {
    if (newQuantity < minQuantity) {
      return
    }

    setQuantity(newQuantity)
    if (inListProduct && newQuantity === 0) {
      removeProduct([inListProduct.id])
    } else {
      updateProduct({
        ...getProduct(item, newQuantity, currency),
        quantity: newQuantity,
      })
    }
  }

  return (
    <div className="ml-3" style={{borderBottom: '1px solid #eee'}}>
      <div className="flex justify-between py-2">
        <div className="col-lg-6">
          <h4
            style={{
              fontSize: '1.5rem',
            }}
            className="m-0 font-montserrat font-normal text-thryv-black-500 mr-2 capitalize"
          >
            {item.name}
          </h4>
          <ParagraphText variant="reg" color="thryv-gray-medium-500">
            {'$' + itemPrice}
          </ParagraphText>
        </div>
        <div className="d-flex align-items-center">
          <Button
            disabled={quantity <= minQuantity}
            variant="primary"
            buttonType="outlined"
            onClick={() => handleRemove(quantity - 1)}
            className="fontSizeUpdate"
          >
            -
          </Button>
          &nbsp;
          {Number(quantity)}
          &nbsp;
          <Button
            disabled={quantity >= maxQuantity}
            variant="primary"
            buttonType="outlined"
            onClick={() => handleAdd(quantity + 1)}
            className="fontSizeUpdate"
          >
            +
          </Button>
        </div>
      </div>
    </div>
  )
}
